import {useEffect} from 'react';
import {publishDisplayEvent, type DisplayEvent} from './customerDisplayClient';

export const useCustomerDisplay = (event?: DisplayEvent): void => {
  const serialized = event ? JSON.stringify(event) : '';
  useEffect(() => {
    if (event) publishDisplayEvent(event);
    // The serialized value intentionally provides structural equality for frames.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialized]);

  useEffect(() => () => {
    publishDisplayEvent({type: 'idle'}, true);
  }, []);
};
